<!--<app-breadcrumb [title]="infoCategory.nameCategory" [breadcrumb]="" [breadcrumbDynamic]="sendBreadcrumbDynamic"></app-breadcrumb>-->
<!-- section start -->
<section class="section-b-space pt-0 gym-product">
    <div class="collection-wrapper">
        <div class="container-fluid px-md-4"> <!-- Contenedor más ancho -->
            <div class="row gx-4 mt-3"> <!-- Reducción de espacio entre columnas -->
                <!-- Columna de filtros (izquierda) -->
                <div class="col-lg-2 media-filter pt-3 pe-0" style="max-width: 220px;"> <!-- Más compacto -->
                    <div class="collection-filter shadow-sm rounded" [class.openFilterbar]="mobileSidebar"> <!-- Sombra para destacar -->
                        <div class="collection-mobile-back py-2 px-3 bg-light" (click)="toggleMobileSidebar()">
                            <span class="filter-back fw-bold">
                                <i class="fa fa-angle-left me-1" aria-hidden="true"></i> Volver
                            </span>
                        </div>
                        
                        <!-- Filtros agrupados con mejor espaciado -->
                        <div class="filter-group">
                            <!-- Categorías -->
                            <app-subcategories *ngIf="categories.length > 0" [subcategories]="categories" [href]="true"
                                [title]="'categoría'" class="border-bottom">
                            </app-subcategories>
                            
                            <!-- Subcategorías -->
                            <app-subcategories *ngIf="subcategories.length > 0" [subcategories]="subcategories" class="border-bottom">
                            </app-subcategories>
                            
                            <!-- Marcas -->
                            <app-brands [products]="products" [brands]="brands" (brandsFilter)="updateFilter($event)" class="border-bottom">
                            </app-brands>
                            
                            <div class="collection-collapse-block border-bottom py-2 px-3 mt-3"></div>
                            <!-- Precio -->
                            <div *ngIf="maxPrice > 0" class="collection-collapse-block border-bottom py-2 px-3" [class.open]="collapse">
                                <h3 class="collapse-block-title" (click)="collapse = !collapse">Precio</h3>
                                <div class="collection-collapse-block-content">
                                    <div class="collection-brand-filter">
                                        <div class="mt-2">
                                            <ng5-slider [(value)]="minPrice" [(highValue)]="maxPrice"
                                                [options]="optionsPrice" (userChangeEnd)="priceFilter($event)"
                                                *ngIf="isBrowser">
                                            </ng5-slider>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Condiciones -->
                            <div class="collection-collapse-block border-bottom py-2 px-3" 
                                *ngIf="sizesAndColors?.conditions?.length > 0">
                                <h3 class="collapse-block-title mb-2 fw-bold d-flex justify-content-between align-items-center" 
                                    (click)="collapse_conditions = !collapse_conditions">
                                    <span>Condiciones</span>
                                    <i class="fa fa-angle-down" [class.rotate-180]="collapse_conditions"></i>
                                </h3>
                                <div class="collection-collapse-block-content" *ngIf="collapse_conditions">
                                    <div class="collection-brand-filter">
                                        <div *ngFor="let item of sizesAndColors.conditions" class="form-check py-1">
                                            <input class="form-check-input" type="checkbox" [value]="item.id"
                                                [checked]="isChecked(item.id, conditionsSelected)" [id]="'cond-'+item.id"
                                                (change)="handleSelection($event, conditionsSelected)">
                                            <label class="form-check-label small" for="cond-{{item.id}}">
                                                {{item.name}}
                                            </label>
                                        </div>
                                        <a class="text-primary small d-block mt-2 cursor-pointer" 
                                            (click)="cleanfilter(conditionsSelected)">
                                            <i class="fa fa-times me-1"></i>Limpiar
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Tallas -->
                            <div class="collection-collapse-block border-bottom py-2 px-3" 
                                *ngIf="sizesAndColors?.sizes?.length > 0">
                                <h3 class="collapse-block-title mb-2 fw-bold d-flex justify-content-between align-items-center" 
                                    (click)="collapse_sizes = !collapse_sizes">
                                    <span>Tallas</span>
                                    <i class="fa fa-angle-down" [class.rotate-180]="collapse_sizes"></i>
                                </h3>
                                <div class="collection-collapse-block-content" *ngIf="collapse_sizes">
                                    <div class="collection-brand-filter">
                                        <div *ngFor="let item of sizesAndColors.sizes" class="form-check py-1">
                                            <input class="form-check-input" type="checkbox" [value]="item.id"
                                                [checked]="isChecked(item.id, sizesSelected)" [id]="'size-'+item.id"
                                                (change)="handleSelection($event, sizesSelected)">
                                            <label class="form-check-label small" for="size-{{item.id}}">
                                                {{item.name}}
                                            </label>
                                        </div>
                                        <a class="text-primary small d-block mt-2 cursor-pointer" 
                                            (click)="cleanfilter(sizesSelected)">
                                            <i class="fa fa-times me-1"></i>Limpiar
                                        </a>
                                    </div>
                                </div>
                            </div>
                            
                            <!-- Colores -->
                            <div class="collection-collapse-block border-bottom py-2 px-3" 
                                *ngIf="sizesAndColors?.colors?.length > 0">
                                <h3 class="collapse-block-title mb-2 fw-bold d-flex justify-content-between align-items-center" 
                                    (click)="collapse_colors = !collapse_colors">
                                    <span>Colores</span>
                                    <i class="fa fa-angle-down" [class.rotate-180]="collapse_colors"></i>
                                </h3>
                                <div class="collection-collapse-block-content" *ngIf="collapse_colors">
                                    <div class="color-filter-grid">
                                        <div *ngFor="let item of sizesAndColors.colors; let i = index" 
                                             class="color-option cursor-pointer"
                                             [style.background-color]="item.code"
                                             [class.selected-color]="isChecked(item.id, colorsSelected)"
                                             (click)="handleColorClick(item.id, colorsSelected)">
                                        </div>
                                    </div>
                                    <a class="text-primary small d-block mt-2 cursor-pointer" 
                                       (click)="cleanfilter(colorsSelected)">
                                        <i class="fa fa-times me-1"></i>Limpiar
                                    </a>
                                </div>
                            </div>
                            
                            <!-- Filtros técnicos -->
                            <div class="technical-filters">
                                <!-- Diámetro exterior -->
                                <div *ngIf="maxDE > 0" class="collection-collapse-block border-bottom py-2 px-3">
                                    <h3 class="collapse-block-title mb-2 fw-bold">Diámetro exterior</h3>
                                    <div class="collection-collapse-block-content">
                                        <ng5-slider [(value)]="minDE" [(highValue)]="maxDE" [options]="optionsDE"
                                            (userChangeEnd)="diametroExteriorFilter($event)" *ngIf="isBrowser">
                                        </ng5-slider>
                                    </div>
                                </div>
                                
                                <!-- Diámetro interior -->
                                <div *ngIf="maxDI > 0" class="collection-collapse-block border-bottom py-2 px-3">
                                    <h3 class="collapse-block-title mb-2 fw-bold">Diámetro interior</h3>
                                    <div class="collection-collapse-block-content">
                                        <ng5-slider [(value)]="minDI" [(highValue)]="maxDI" [options]="optionsDI"
                                            (userChangeEnd)="diametroInteriorFilter($event)" *ngIf="isBrowser">
                                        </ng5-slider>
                                    </div>
                                </div>
                                
                                <!-- Altura -->
                                <div *ngIf="maxL > 0" class="collection-collapse-block border-bottom py-2 px-3">
                                    <h3 class="collapse-block-title mb-2 fw-bold">Altura</h3>
                                    <div class="collection-collapse-block-content">
                                        <ng5-slider [(value)]="minL" [(highValue)]="maxL" [options]="optionsL"
                                            (userChangeEnd)="largoFilter($event)" *ngIf="isBrowser">
                                        </ng5-slider>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
                <!-- Contenido principal -->
                <div class="col-lg-9 collection-content ps-4 pe-4"> <!-- Ajuste de padding -->
                    <div class="page-main-content">
                        <!-- Banner de categoría -->
                        <div class="category-banner-section mb-4 bg-white rounded shadow-sm overflow-hidden" style="height: 350px;">
                            <div class="row g-0 align-items-stretch h-100">
                                <!-- Imagen -->
                                <div class="col-md-6 h-auto">
                                    <div class="img-fit" style="overflow: hidden;">
                                        <img [defaultImage]="loadGif" [lazyLoad]="infoCategory.bannerCategory"
                                            class="img-fluid object-fit-cover"
                                            style="min-height: 100%; object-position: center;"
                                            alt="Banner categoría">
                                    </div>
                                </div>
                                <!-- Contenido -->
                                <div class="col-md-6 col-sm-6 bg-light h-auto" style="overflow:visible;">
                                    <div class="p-4 h-100 d-flex flex-column justify-content-center">
                                        <h1 class="category-title mb-3 fw-bold">{{infoCategory.nameCategory}}</h1>
                                        <h3 *ngIf="infoCategory.category_highlights_description" 
                                            class="category-highlight mb-3 text-primary">
                                            {{infoCategory.category_highlights_description}}
                                        </h3>
                                        <p *ngIf="infoCategory.category_description" class="category-description mb-0 text-justify">
                                            {{infoCategory.category_description}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Filtro móvil y tags -->
                        <div class="d-flex flex-wrap align-items-center justify-content-between mb-3">
                            <!-- Botón filtro móvil -->
                            <div class="filter-main-btn mb-2">
                                <button class="btn btn-outline-primary btn-sm" (click)="toggleMobileSidebar()">
                                    <i class="fa fa-filter me-1"></i> Filtros
                                </button>
                            </div>
                            
                            <!-- Tags de filtros activos -->
                            <div class="filter-tags-container" *ngIf="tags.length > 0">
                                <div class="d-flex flex-wrap align-items-center">
                                    <span *ngFor="let tag of tags" class="badge bg-light text-dark me-2 mb-2 d-flex align-items-center">
                                        {{tag}}
                                        <i class="fa fa-times ms-2 cursor-pointer" (click)="removeTag(tag)"></i>
                                    </span>
                                    <a class="text-primary small cursor-pointer mb-2" (click)="removeAllTags()">
                                        <i class="fa fa-times-circle me-1"></i>Borrar todo
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                        <!-- Contenido de productos -->
                        <div class="collection-product-wrapper" id="products">
                            <!-- Controles de vista -->
                            <app-grid [products]="products" [paginate]="paginate" [layoutView]="layoutView"
                                [sortBy]="sortBy" (setGrid)="updateGridLayout($event)"
                                (setLayout)="updateLayoutView($event)" (sortedBy)="sortByFilter($event)">
                            </app-grid>
                            
                            <!-- Listado de productos -->
                            <div class="product-wrapper-grid" [ngClass]="layoutView">
                                <div class="row g-3"> <!-- Espaciado entre productos -->
                                    <div class="col-grid-box" [ngClass]="grid" *ngFor="let product of products">
                                        <div class="product-box shadow-sm rounded overflow-hidden"> <!-- Tarjeta con sombra -->
                                            <app-product-box-one [product]="product"
                                                [currency]="productService?.Currency" [thumbnail]="false"
                                                [cartModal]="true">
                                            </app-product-box-one>
                                        </div>
                                    </div>
                                </div>
                                
                                <!-- Estados de carga -->
                                <div class="text-center my-5 py-5" *ngIf="!products.length && showLoading">
                                    <div class="spinner-border text-primary" role="status" *ngIf="loading">
                                        <span class="visually-hidden">Cargando...</span>
                                    </div>
                                    <p class="mt-2">Cargando productos...</p>
                                </div>
                                
                                <div class="text-center my-5 py-4" *ngIf="!products.length && !showLoading">
                                    <img src="assets/images/empty-search.jpg" class="img-fluid mb-4" style="max-width: 300px;">
                                    <h4 class="mb-3">¡No encontramos lo que buscas!</h4>
                                    <p class="text-muted mb-4">Intenta ajustar los filtros o buscar con otros términos.</p>
                                    <a [routerLink]="['/products']" class="btn btn-primary">
                                        <i class="fa fa-arrow-left me-2"></i>Ver todos los productos
                                    </a>
                                </div>
                            </div>
                            
                            <!-- Carga infinita -->
                            <div class="product-infinitescroll mt-4">
                                <div class="text-center">
                                    <div *ngIf="loading" class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Cargando...</span>
                                    </div>
                                    <button *ngIf="!loading && !finished" (click)="onScroll()"
                                        class="btn btn-outline-primary mt-3">
                                        <i class="fa fa-plus me-2"></i>Mostrar más productos
                                    </button>
                                    <div *ngIf="finished && products.length" class="text-muted mt-3">
                                        Has llegado al final de la lista
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Columna derecha para nuevo productos -->
                <div class="col-lg-2 media-filter pt-3 ps-0" style="max-width: 220px;">
                    <div class="collection-filter shadow-sm rounded h-100 row">
                        <!-- Productos destacados -->
                        <app-product-box-vertical-slider [title]="'Nuevos productos'" class="mt-3">
                        </app-product-box-vertical-slider>
                        <!-- Banners adicionales -->
                        <div class="sidebar-banner p-3">
                            <img src="assets/images/sidebar-promo.jpg" class="img-fluid rounded" alt="Promoción">
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- section End -->